import { AnimatedSection } from '@/hooks/useScrollAnimation';
import { TEAM_MEMBERS } from '@/data/team';

const Team = () => {
  return (
    <AnimatedSection className="section-padding bg-secondary/30" id="equipe">
      <div className="container-mobile">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Nossa Equipe
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mb-3">
            Nossa Equipe
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Uma equipe dedicada ao seu cuidado integral, unindo expertise e humanização.
          </p>
        </div>

        {/* Team Grid - Horizontal scroll on mobile. No desktop e flex com
            justify-center, nao grid de 5 colunas: com 4 pessoas o grid deixava
            a quinta coluna vazia e a equipe encostada na esquerda. Assim a
            fileira fica centralizada com qualquer numero de membros. */}
        <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory md:flex-wrap md:justify-center md:gap-x-12 md:gap-y-10 md:overflow-visible md:pb-0">
          {TEAM_MEMBERS.map((member) => (
            <div
              key={member.id}
              className="flex-shrink-0 w-[200px] md:w-56 snap-center"
            >
              <div className="text-center group">
                {/* Circular Photo */}
                <div className="relative w-40 h-40 mx-auto mb-4">
                  <div className="w-full h-full rounded-full overflow-hidden border-4 border-background shadow-lg group-hover:scale-105 transition-transform">
                    <img
                      src={member.image}
                      srcSet={member.srcSet}
                      sizes="160px"
                      alt={member.name}
                      width={320}
                      height={320}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  {/* Decorative ring */}
                  <div className="absolute inset-0 rounded-full border-2 border-primary/20 scale-110" />
                </div>

                {/* Info */}
                <h3 className="font-serif text-lg font-semibold text-foreground mb-1">
                  {member.name}
                </h3>
                <p className="text-primary text-sm font-medium">
                  {member.role}
                </p>
                {member.registro && (
                  <p className="text-muted-foreground text-xs mt-1">
                    {member.registro}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Scroll indicator on mobile */}
        <div className="flex justify-center gap-2 mt-4 md:hidden">
          {TEAM_MEMBERS.map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-primary/30"
            />
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Team;
